export const API_URL =
  process.env.REACT_APP_API_URL ||
  (window.location.hostname === "localhost"
    ? "http://localhost:8181"
    : "https://stayhealthy-api.aminajaved.com");
